import { render, staticRenderFns } from "./Backgroundimage.vue?vue&type=template&id=2a5f7b0c&"
import script from "./Backgroundimage.vue?vue&type=script&lang=js&"
export * from "./Backgroundimage.vue?vue&type=script&lang=js&"
import style0 from "./Backgroundimage.vue?vue&type=style&index=0&id=2a5f7b0c&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a5f7b0c')) {
      api.createRecord('2a5f7b0c', component.options)
    } else {
      api.reload('2a5f7b0c', component.options)
    }
    module.hot.accept("./Backgroundimage.vue?vue&type=template&id=2a5f7b0c&", function () {
      api.rerender('2a5f7b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attribute/Backgroundimage.vue"
export default component.exports